// eslint-disable-next-line monorepo-dependencies/no-unlisted-package-import
import type { CastReceiverContext } from 'chromecast-caf-receiver/cast.framework';
// eslint-disable-next-line monorepo-dependencies/no-unlisted-package-import
import type { LoadRequestData } from 'chromecast-caf-receiver/cast.framework.messages';
import { makeMediaObject, mapMediaToMediaInformation } from '../../services/media';
import { bootstrapAction, loadRequestFilter, mediaFilter } from '../extensions';
import cast from '../../types/chromecast-caf-receiver';
import type { ChromecastPlayRequestCustomData } from '../../types';
import store, { USER_INFORMATION } from '../../store';

export class AutoNextPlugin {
  init() {
    bootstrapAction.register(this.bootstrap.bind(this));
    mediaFilter.register(this.mediaTransformer.bind(this));
    loadRequestFilter.register(this.loadTransformer.bind(this));
  }

  async loadTransformer(loadRequestData: LoadRequestData) {
    this.requestCustomData = loadRequestData.customData;
    return loadRequestData;
  }

  private mediaQueue: {
    metadata: {
      duration: number | undefined;
      image: { __typename: 'Art'; url: string | null } | null;
      isLive: boolean;
      subtitle: string | null;
      channel: null;
      guid: string;
      season: number | null;
      episode: number | null;
      title: string | null;
      type: 'BROADCAST' | 'EPISODE' | 'EVENT' | 'MOVIE' | 'PROGRAM' | 'SERIES' | null;
    };
  }[] = [];

  private requestCustomData: ChromecastPlayRequestCustomData;

  async mediaTransformer(media: ReturnType<typeof makeMediaObject>, accessToken: string) {
    this.mediaQueue = media.queue && media.queue.length ? media.queue : [];
    return media;
  }

  async bootstrap(context: CastReceiverContext) {
    const playerManager = context.getPlayerManager();
    const queueManager = playerManager.getQueueManager();
    playerManager.addEventListener(cast.framework.events.EventType.TIME_UPDATE, event => {
      const duration = playerManager.getDurationSec();
      if (duration === 0) return;

      const { currentMediaTime } = event;

      if (currentMediaTime && duration - currentMediaTime < 60 && this.mediaQueue.length > 0) {
        const user = store.get(USER_INFORMATION);
        queueManager?.insertItems(
          this.mediaQueue.map(next => {
            return Object.assign(new cast.framework.messages.QueueItem(), {
              media: mapMediaToMediaInformation(next),
              preloadTime: 30,
              customData: {
                ...this.requestCustomData,
                // We update the accessToken because our test sender has a feature where we can update the users access token while playing
                accessToken: user.accessToken,
                playbackInitiationType: 'autonext',
              },
            });
          })
        );
        this.mediaQueue = [];
      }
    });
  }
}
